export const containerCss = 'flex flex-col gap-5'
export const leftColumnWidth = 208
export const leftColumnGap = 56
export const desktopContainerCss = 'md:w-desktopWidth md:mt-5 md:flex-row md:gap-[56px]'
